import { Formulario } from "@/contexts/fiscalizacao/formulario/model/Formulario";
import { FormularioRespostaControle } from "@/contexts/fiscalizacao/formulario/model/FormularioRespostaControle";
import { api } from "@/shared/api/api";

export const createFormularioApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<Formulario[]>(`/formularios/todos`, {
      headers,
    });
    return data;
  };

  const listRespostasControleByMunicipio = async (municipioId: number) => {
    const { data } = await api.get<FormularioRespostaControle[]>(
      `/formularios-respostas-controle/municipio/${municipioId}`,
      { headers }
    );
    return data;
  };

  return { listAll, listRespostasControleByMunicipio };
};
